import { useEffect, useState, useMemo } from "react";
import api from "@/lib/api";
import { DataStampaField, oggiDmy } from "../components/DataStampaField";

export default function PrivacyNominePage() {
  const [items, setItems] = useState([]);
  const [tipi, setTipi] = useState([]);
  const [docenti, setDocenti] = useState([]);
  const [modelli, setModelli] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [err, setErr] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [stampaFor, setStampaFor] = useState(null);
  const [anteprimaFor, setAnteprimaFor] = useState(null);

  const carica = async () => {
    setLoading(true);
    try {
      const [rn, rt, rd, rm] = await Promise.all([
        api.get("/privacy/nomine"),
        api.get("/privacy/lookup/tipi-nomina"),
        api.get("/docenti", { params: { limit: 500, attivo: true } }),
        api.get("/privacy/modelli", { params: { ambito: "nomina" } }),
      ]);
      setItems(rn.data.items || []);
      setTipi(rt.data.items || []);
      const list = (rd.data?.data || [])
        .map(d => ({ codice: String(d.codice || ""), cognome: d.cognome || "", nome: d.nome || "" }))
        .filter(d => d.codice)
        .sort((a, b) => (a.cognome + a.nome).localeCompare(b.cognome + b.nome));
      setDocenti(list);
      setModelli(rm.data?.items || []);
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  const salva = async () => {
    try {
      if (editing._isNew) {
        const payload = { ...editing };
        delete payload.codice;
        delete payload._isNew;
        await api.post("/privacy/nomine", payload);
      } else {
        await api.put(`/privacy/nomine/${encodeURIComponent(editing._orig_codice || editing.codice)}`, editing);
      }
      setEditing(null);
      await carica();
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
  };

  const elimina = async (r) => {
    if (!window.confirm(`Eliminare la nomina ${r.codice} (${r.tipo_descrizione} - ${r.docente_cognome} ${r.docente_nome})?`)) return;
    try { await api.delete(`/privacy/nomine/${encodeURIComponent(r.codice)}`); await carica(); }
    catch (e) { setErr(e.response?.data?.detail || "Errore"); }
  };

  const handleImportExcel = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const mode = window.confirm(
      `Importare "${file.name}"?\n\n` +
      `✓ OK   → MERGE (aggiorna per codice, mantiene le altre nomine)\n` +
      `✗ ANNULLA  → scegli Replace (cancella TUTTE le nomine attuali prima di importare)`
    ) ? "upsert" : null;
    let finalMode = mode;
    if (finalMode === null) {
      if (!window.confirm(`SOSTITUZIONE COMPLETA: cancellerà tutte le ${items.length} nomine attuali (compresi i file allegati) e caricherà quelle del file.\n\nSei sicuro?`)) return;
      finalMode = "replace";
    }
    setImporting(true); setErr(null); setImportResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/privacy/nomine/import-excel?mode=${finalMode}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setImportResult(r.data);
      await carica();
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Errore import");
    } finally {
      setImporting(false);
    }
  };

  const docMap = useMemo(() => Object.fromEntries(docenti.map(d => [d.codice, d])), [docenti]);

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12, gap: 10 }}>
        <h2 style={{ color: "#37474f", fontSize: 18, margin: 0 }}>📜 Nomine · {items.length}</h2>
        <button onClick={carica} style={{ padding: "7px 14px", background: "#455a64", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🔄 Aggiorna</button>
        <label
          data-testid="priv-nom-import-btn"
          title="Importa nomine da file Excel (.xlsx). Colonne richieste: Tipo Codice (o Descrizione), Docente Codice (o Cognome e Nome), Dal, Al. Codice opzionale."
          style={{
            marginLeft: "auto",
            padding: "7px 14px",
            background: importing ? "#78909c" : "#2e7d32",
            color: "white", fontSize: 12, fontWeight: 700,
            cursor: importing ? "wait" : "pointer",
            display: "inline-flex", alignItems: "center", gap: 6,
          }}>
          {importing ? "⏳ Import..." : "📥 Importa Excel"}
          <input type="file" accept=".xlsx,.xlsm"
            onChange={handleImportExcel}
            disabled={importing}
            data-testid="priv-nom-import-file"
            style={{ display: "none" }} />
        </label>
        <button
          onClick={() => setEditing({ _isNew: true, codice: "", tipo_codice: "", docente_codice: "", dal: "", al: "" })}
          data-testid="priv-nom-new"
          style={{ padding: "7px 16px", background: "#37474f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          ➕ Nuova Nomina
        </button>
      </div>
      {err && <div style={{ padding: 10, background: "#fff0f0", color: "#c00", fontSize: 12, marginBottom: 10 }}>{err} <button onClick={() => setErr(null)} style={{ float: "right", background: "none", border: "none", cursor: "pointer", color: "#c00", fontWeight: 700 }}>✕</button></div>}
      {importResult && (
        <div data-testid="priv-nom-import-result"
          style={{ padding: 10, background: importResult.errors_count ? "#fff8e1" : "#e8f5e9", color: importResult.errors_count ? "#f57f17" : "#1b5e20", fontSize: 12, marginBottom: 10, border: "1px solid " + (importResult.errors_count ? "#ffd54f" : "#a5d6a7") }}>
          {importResult.errors_count ? "⚠" : "✅"} Import ({importResult.mode}): <b>{importResult.inserted}</b> inseriti, <b>{importResult.updated}</b> aggiornati
          {importResult.deleted_existing ? <>, <b>{importResult.deleted_existing}</b> cancellati</> : null}
          {importResult.skipped ? <>, <b>{importResult.skipped}</b> scartati</> : null}
          {importResult.errors_count > 0 && (
            <ul style={{ margin: "6px 0 0 16px", padding: 0 }}>
              {importResult.errors.map((e, i) => <li key={i} style={{ fontSize: 11 }}>{e}</li>)}
              {importResult.errors_count > importResult.errors.length && (
                <li style={{ fontSize: 11, fontStyle: "italic" }}>...e altri {importResult.errors_count - importResult.errors.length} errori</li>
              )}
            </ul>
          )}
          <button onClick={() => setImportResult(null)} style={{ float: "right", background: "none", border: "none", cursor: "pointer", fontWeight: 700, color: "inherit" }}>✕</button>
        </div>
      )}

      <div style={{ background: "white", border: "1px solid #ccc" }}>
        <table className="sw-table sw-table-compact" style={{ fontSize: 11 }}>
          <thead className="thead-blue">
            <tr>
              <th style={{ width: 70 }}>COD</th>
              <th style={{ minWidth: 220 }}>DESCRIZIONE</th>
              <th style={{ width: 90 }}>COD DOC</th>
              <th style={{ minWidth: 240 }}>COGNOME E NOME</th>
              <th style={{ width: 110 }}>DAL</th>
              <th style={{ width: 110 }}>AL</th>
              <th style={{ width: 240, textAlign: "center" }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessuna nomina. Clicca <b>+ Nuova Nomina</b>.</td></tr>
            )}
            {items.map(r => (
              <tr key={r.codice} data-testid={`priv-nom-row-${r.codice}`}>
                <td style={{ fontFamily: "Consolas, monospace", fontWeight: 700, color: "#0d47a1", textAlign: "center" }}>{r.tipo_codice}</td>
                <td style={{ fontWeight: 600 }}>{r.tipo_descrizione || r.tipo_codice}</td>
                <td style={{ fontFamily: "Consolas, monospace", textAlign: "center", color: "#888" }}>{r.docente_codice}</td>
                <td style={{ fontWeight: 600 }}>{r.docente_cognome} {r.docente_nome}</td>
                <td>{r.dal}</td>
                <td>{r.al ? r.al : <span style={{ color: "#0d47a1", fontStyle: "italic", fontWeight: 600 }}>fino a revoca</span>}</td>
                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                  <button onClick={() => setAnteprimaFor(r.codice)}
                    data-testid={`priv-nom-ant-${r.codice}`}
                    title="Anteprima documento di nomina (PDF)"
                    style={{ background: "#6a1b9a", color: "white", border: "none", padding: "3px 8px", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>👁 Anteprima</button>
                  <button onClick={() => setStampaFor(r.codice)}
                    data-testid={`priv-nom-stp-${r.codice}`}
                    title="Stampa documento di nomina (DOCX/PDF)"
                    style={{ background: "#c62828", color: "white", border: "none", padding: "3px 8px", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>🖨 Stampa</button>
                  <button onClick={() => setEditing({ ...r, _orig_codice: r.codice })}
                    data-testid={`priv-nom-edit-${r.codice}`}
                    style={{ background: "#1565c0", color: "white", border: "none", padding: "3px 10px", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>✏</button>
                  <button onClick={() => elimina(r)}
                    data-testid={`priv-nom-del-${r.codice}`}
                    style={{ background: "#c62828", color: "white", border: "none", padding: "3px 10px", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && <NominaEditModal editing={editing} setEditing={setEditing} tipi={tipi} docenti={docenti} docMap={docMap} onSave={salva} />}
      {stampaFor && <StampaNominaModal codice={stampaFor} modelli={modelli} onClose={() => setStampaFor(null)} />}
      {anteprimaFor && <AnteprimaNominaModal codice={anteprimaFor} modelli={modelli} onClose={() => setAnteprimaFor(null)} />}
    </div>
  );
}

function NominaEditModal({ editing, setEditing, tipi, docenti, docMap, onSave }) {
  const setF = (k, v) => setEditing({ ...editing, [k]: v });
  const selectedDoc = docMap[editing.docente_codice];
  return (
    <div onClick={() => setEditing(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "white", width: 640, borderRadius: 4, overflow: "hidden" }}>
        <div style={{ background: "#37474f", color: "white", padding: "12px 18px", fontWeight: 700, fontSize: 14, display: "flex", justifyContent: "space-between" }}>
          {editing._isNew ? "➕ Nuova Nomina" : `✏ Modifica Nomina ${editing._orig_codice}`}
          <button onClick={() => setEditing(null)} style={{ background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer" }}>✕</button>
        </div>
        <div style={{ padding: 18 }}>
          <div style={{ display: "grid", gridTemplateColumns: "140px 1fr", gap: 10, marginBottom: 10 }}>
            <div>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>CODICE</label>
              <input value={editing._isNew ? "— AUTO —" : editing.codice}
                disabled
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12, fontFamily: "Consolas, monospace", fontWeight: 700, background: "#f5f5f5" }} />
            </div>
            <div>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>TIPO NOMINA *</label>
              <select value={editing.tipo_codice || ""} onChange={e => setF("tipo_codice", e.target.value)}
                data-testid="priv-nom-m-tipo"
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }}>
                <option value="">— seleziona —</option>
                {tipi.map(t => <option key={t.codice} value={t.codice}>{t.codice} — {t.descrizione}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>DOCENTE NOMINATO *</label>
            <select value={editing.docente_codice || ""} onChange={e => setF("docente_codice", e.target.value)}
              data-testid="priv-nom-m-docente"
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }}>
              <option value="">— seleziona docente —</option>
              {docenti.map(d => <option key={d.codice} value={d.codice}>{d.codice} — {d.cognome} {d.nome}</option>)}
            </select>
            {selectedDoc && (
              <div style={{ fontSize: 10, color: "#2e7d32", marginTop: 3 }}>✓ {selectedDoc.cognome} {selectedDoc.nome}</div>
            )}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>DAL *</label>
              <input type="text" value={editing.dal || ""} onChange={e => setF("dal", e.target.value)}
                placeholder="dd/mm/yyyy"
                data-testid="priv-nom-m-dal"
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
            </div>
            <div>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>AL <span style={{ color: "#888", fontWeight: 400 }}>(vuoto = fino a revoca)</span></label>
              <input type="text" value={editing.al || ""} onChange={e => setF("al", e.target.value)}
                placeholder="dd/mm/yyyy oppure vuoto"
                data-testid="priv-nom-m-al"
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
              <label style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 4, fontSize: 11, color: "#0d47a1", cursor: "pointer" }}>
                <input type="checkbox"
                  data-testid="priv-nom-m-fino-a-revoca"
                  checked={!editing.al}
                  onChange={e => { if (e.target.checked) setF("al", ""); }} />
                Fino a revoca
              </label>
            </div>
          </div>
          {!editing._isNew && (
            <div style={{ marginTop: 14, padding: 10, background: "#e3f2fd", fontSize: 11, color: "#0d47a1" }}>
              💡 Per generare la lettera/atto di nomina usa i bottoni <b>👁 Anteprima</b> e <b>🖨 Stampa</b> nella lista (i modelli con ambito "nomina" vanno caricati in <b>Privacy → Catalogo Docx</b>).
            </div>
          )}
        </div>
        <div style={{ padding: "10px 18px", borderTop: "1px solid #eee", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button onClick={() => setEditing(null)} style={{ padding: "6px 14px", background: "white", color: "#666", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
          <button onClick={onSave} data-testid="priv-nom-save"
            style={{ padding: "6px 18px", background: "#37474f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>💾 Salva</button>
        </div>
      </div>
    </div>
  );
}


// ============================================================
// STAMPA / ANTEPRIMA per ambito NOMINA
// ============================================================
function StampaNominaModal({ codice, modelli: initialModelli, onClose }) {
  const [modelli, setModelli] = useState(initialModelli || []);
  const [sel, setSel] = useState("");
  const [err, setErr] = useState("");
  const [dataStampa, setDataStampa] = useState(oggiDmy());

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/privacy/modelli", { params: { ambito: "nomina" } });
        if (alive) setModelli(r.data?.items || []);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  const scarica = async (formato) => {
    if (!sel) return;
    try {
      const r = await api.get(`/privacy/modelli/${encodeURIComponent(sel)}/genera`, {
        params: { nomina_codice: codice, formato, data_stampa: dataStampa },
        responseType: "blob",
      });
      const blob = new Blob([r.data], { type: r.headers["content-type"] });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      const cd = r.headers["content-disposition"] || "";
      const m = cd.match(/filename="?([^"]+)"?/);
      a.download = m ? m[1] : `nomina_${codice}.${formato}`;
      document.body.appendChild(a); a.click(); a.remove();
      onClose();
    } catch (e) {
      let msg = "Errore generazione documento";
      try { const t = await e.response?.data?.text?.(); if (t) msg = JSON.parse(t).detail || msg; } catch { /* ignore */ }
      setErr(msg);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-stampa-modal"
        style={{ background: "white", padding: 20, minWidth: 480, maxWidth: 620 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 12, color: "#0d47a1" }}>🖨 Stampa nomina — {codice}</div>
        {err && <div style={{ background: "#ffebee", color: "#c62828", padding: 8, fontSize: 12, marginBottom: 10 }}>{err}</div>}
        <DataStampaField value={dataStampa} onChange={setDataStampa} testid="pn-stampa-data" />
        <div style={{ fontSize: 11, color: "#666", marginBottom: 4 }}>MODELLO (ambito = nomina)</div>
        <select value={sel} onChange={e => setSel(e.target.value)} data-testid="pn-stampa-modello-select"
          style={{ width: "100%", padding: "6px 10px", border: "1px solid #ccc", fontSize: 12, marginBottom: 16 }}>
          <option value="">— scegli un modello —</option>
          {modelli.map(m => (
            <option key={m.codice} value={m.codice}>{m.codice} — {m.nome}{m.filename ? "" : " (no file)"}</option>
          ))}
        </select>
        {modelli.length === 0 && (
          <div style={{ background: "#fff3e0", padding: 8, fontSize: 11, color: "#e65100", marginBottom: 12 }}>
            ⚠ Nessun modello con ambito &quot;nomina&quot;. Caricane uno in <b>Privacy → Catalogo Docx</b> scegliendo ambito = Nomina.
          </div>
        )}
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "8px 16px", background: "white", border: "1px solid #999", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
          <button onClick={() => scarica("docx")} disabled={!sel} data-testid="pn-stampa-docx"
            style={{ padding: "8px 16px", background: sel ? "#1565c0" : "#bbb", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: sel ? "pointer" : "not-allowed" }}>📄 Scarica DOCX</button>
          <button onClick={() => scarica("pdf")} disabled={!sel} data-testid="pn-stampa-pdf"
            style={{ padding: "8px 16px", background: sel ? "#c62828" : "#bbb", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: sel ? "pointer" : "not-allowed" }}>📕 Scarica PDF</button>
        </div>
      </div>
    </div>
  );
}

function AnteprimaNominaModal({ codice, modelli: initialModelli, onClose }) {
  const [modelli, setModelli] = useState(initialModelli || []);
  const [sel, setSel] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [err, setErr] = useState("");
  const [dataStampa, setDataStampa] = useState(oggiDmy());

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/privacy/modelli", { params: { ambito: "nomina" } });
        if (alive) setModelli(r.data?.items || []);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!sel) return;
    let alive = true;
    let createdUrl = "";
    (async () => {
      setLoading(true); setErr("");
      try {
        const r = await api.get(`/privacy/modelli/${encodeURIComponent(sel)}/genera`, {
          params: { nomina_codice: codice, formato: "pdf", inline: 1, data_stampa: dataStampa },
          responseType: "blob",
        });
        if (!alive) return;
        const blob = new Blob([r.data], { type: "application/pdf" });
        createdUrl = URL.createObjectURL(blob);
        setPdfUrl(createdUrl);
      } catch (e) {
        if (!alive) return;
        let msg = "Errore generazione anteprima";
        try { const t = await e.response?.data?.text?.(); if (t) msg = JSON.parse(t).detail || msg; } catch { /* ignore */ }
        setErr(msg); setPdfUrl("");
      } finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; if (createdUrl) URL.revokeObjectURL(createdUrl); };
  }, [sel, codice, dataStampa]);

  const scarica = async (formato) => {
    try {
      const r = await api.get(`/privacy/modelli/${encodeURIComponent(sel)}/genera`, {
        params: { nomina_codice: codice, formato, data_stampa: dataStampa }, responseType: "blob",
      });
      const blob = new Blob([r.data], { type: r.headers["content-type"] });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      const cd = r.headers["content-disposition"] || "";
      const m = cd.match(/filename="?([^"]+)"?/);
      a.download = m ? m[1] : `nomina_${codice}.${formato}`;
      document.body.appendChild(a); a.click(); a.remove();
    } catch { setErr("Errore download"); }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-anteprima-modal"
        style={{ background: "white", width: "90vw", maxWidth: 1200, height: "90vh", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "12px 16px", background: "#6a1b9a", color: "white", display: "flex", alignItems: "center", gap: 12, justifyContent: "space-between" }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>👁 Anteprima nomina — {codice}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.9 }} title="Data di stampa (placeholder «Data.Stampa»)">📅 Data:</span>
            <input type="text" value={dataStampa} onChange={e => setDataStampa(e.target.value)}
              placeholder="gg/mm/aaaa"
              data-testid="pn-ant-data-stampa"
              title="Data di stampa (placeholder «Data.Stampa»)"
              style={{ padding: "4px 8px", border: "1px solid #ccc", fontSize: 12, width: 100, color: "#37474f", background: "white" }} />
            <select value={sel} onChange={e => setSel(e.target.value)} data-testid="pn-ant-modello-select"
              style={{ padding: "4px 8px", border: "1px solid #ccc", fontSize: 12, minWidth: 280, color: "#37474f", background: "white" }}>
              <option value="">— scegli un modello —</option>
              {modelli.map(m => (
                <option key={m.codice} value={m.codice}>{m.codice} — {m.nome}{m.filename ? "" : " (no file)"}</option>
              ))}
            </select>
            <button onClick={() => scarica("docx")} disabled={!sel || loading}
              style={{ padding: "5px 12px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: !sel || loading ? "not-allowed" : "pointer", opacity: !sel || loading ? 0.5 : 1 }}>📄 DOCX</button>
            <button onClick={() => scarica("pdf")} disabled={!sel || loading}
              style={{ padding: "5px 12px", background: "#c62828", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: !sel || loading ? "not-allowed" : "pointer", opacity: !sel || loading ? 0.5 : 1 }}>📕 PDF</button>
            <button onClick={onClose} style={{ background: "none", border: "none", color: "white", fontSize: 22, cursor: "pointer", padding: "0 4px" }}>✕</button>
          </div>
        </div>
        <div style={{ flex: 1, background: "#37474f", position: "relative" }}>
          {loading && <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: 13, fontWeight: 700 }}>⏳ Generazione anteprima...</div>}
          {!loading && err && <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ background: "#c62828", color: "white", padding: "12px 18px", fontSize: 12, fontWeight: 700, maxWidth: 600, textAlign: "center" }}>{err}</div></div>}
          {!loading && !err && pdfUrl && <iframe src={pdfUrl} title="Anteprima" style={{ width: "100%", height: "100%", border: "none", background: "white" }} />}
          {!loading && !err && !pdfUrl && !sel && (
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, color: "#cfd8dc", fontSize: 14 }}>
              <div style={{ fontSize: 48 }}>📄</div>
              <div style={{ fontWeight: 700 }}>Scegli un modello dall&apos;alto per generare l&apos;anteprima</div>
              {modelli.length === 0 && <div style={{ fontSize: 12, color: "#ff8a80" }}>Nessun modello con ambito &quot;nomina&quot;. Carica un .docx in <b>Privacy → Catalogo Docx</b>.</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
